<div class="uploader-modal">
  <div class="uploader-modal-header">
    <h2>{{ "ClientApp.FrontOffice.Catalog.ItemCategory.SelectGroupImage" | translate }}</h2>
    <button (click)="close()"><i class="icon-close-o"></i></button>
  </div>

  <div class="uploader-modal-body">
    <div class="image-box">
      <div class="image" [class.active]="i === selectedImage" *ngFor="let image of images; index as i" (click)="select(i)">
        <img [src]="image" />
      </div>
    </div>
  </div>

  <div class="uploader-modal-footer">
    <button class="cancel" (click)="close()">{{ "ClientApp.FrontOffice.Catalog.ItemCategory.Cancel" | translate }}</button>
    <button class="save" (click)="onSubmit()">{{ "ClientApp.FrontOffice.Catalog.ItemCategory.Save" | translate }}</button>
  </div>
</div>
